module.exports = __webpack_public_path__ + "img/logo.a10d1d35.svg";